// Visual theme tokens for EventInfoCard.
// Keys are referenced in events.js via theme: 'key'
// Data only — no JSX or component logic here.
// To add a theme: add an entry and use its key in events.js

export const EVENT_THEMES = {
  default: {
    icon: '🤝',
    accent: '#E57542',
    bg: '#FEF3E9',
    border: '#F0A578',
    label: null
  },
  valentines: {
    icon: '💝',
    accent: '#e8446a',
    bg: '#fff0f3',
    border: '#f4a7b9',
    label: "Valentine's Special"
  },
  romance: {
    icon: '💝',
    accent: '#e8446a',
    bg: '#fff0f3',
    border: '#f4a7b9',
    label: null
  }
};